function openSidebarCollapse(collapse: HTMLElement, wrapper: HTMLElement): void {
	collapse.classList.add('show');
	if (!collapse.id) {
		return;
	}
	const href = `#${collapse.id}`;
	const toggle = wrapper.querySelector<HTMLElement>(`a[href="${href}"]`);
	if (!toggle) {
		return;
	}
	toggle.setAttribute('aria-expanded', 'true');
	toggle.classList.remove('collapsed');
}

export function scrollSidebarActiveItemIntoView(wrapper: HTMLElement | null): boolean {
	if (!wrapper) {
		return false;
	}
	const leaf = wrapper.querySelector<HTMLElement>('li.sub-sub-item.active');
	const items = wrapper.querySelectorAll<HTMLElement>('li.active');
	const active = leaf || items[items.length - 1];
	if (!active) {
		return false;
	}

	let ancestor: HTMLElement | null = active.parentElement;
	while (ancestor && ancestor !== wrapper) {
		if (ancestor.classList.contains('collapse')) {
			openSidebarCollapse(ancestor, wrapper);
		}
		ancestor = ancestor.parentElement;
	}
	items.forEach((item) => {
		const sibling = item.nextElementSibling;
		if (sibling instanceof HTMLElement && sibling.classList.contains('collapse')) {
			openSidebarCollapse(sibling, wrapper);
		}
	});

	const target = wrapper.querySelector<HTMLElement>('li.sub-sub-item.active') || active;
	const offset = target.getBoundingClientRect().top - wrapper.getBoundingClientRect().top + wrapper.scrollTop;
	wrapper.scrollTop = Math.max(0, offset - wrapper.clientHeight / 3);
	if (typeof target.scrollIntoView === 'function') {
		target.scrollIntoView({ block: 'center', inline: 'nearest' });
	}
	return true;
}
